import React from "react";
import { Navigate } from "react-router-dom";
import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile";
import StudentsPage from "views/admin/students";
import InstructorsPage from "views/admin/instructors";
import EntitiesPage from "views/admin/entities";
import AcademicPage from "./views/admin/academic";
import RolesPage from "views/admin/roles";
import NotificationsPage from "views/admin/notifications";
import NotificationDetailsPage from "views/admin/notifications/NotificationDetailsPage";
import LearningAnalyticsPage from "views/admin/learning-analytics";
import AdminCourseChatPage from "views/admin/course-chat/AdminCourseChatPage";
import AdminJoinRequestsPage from "views/admin/join-requests";
import AdminWalletsPage from "views/admin/wallets";
import SupportRequestsPage from "views/admin/support-requests";
import HomeBannersPage from "views/admin/home-banners";
import AdminSignIn from "views/auth/AdminSignIn";
import {
  MdAccountBalanceWallet,
  MdAdminPanelSettings,
  MdBarChart,
  MdHome,
  MdInsights,
  MdMenuBook,
  MdNotifications,
  MdPeople,
  MdPersonAdd,
  MdSecurity,
  MdSchool,
  MdSystemUpdateAlt,
  MdSupportAgent,
  MdCampaign,
} from "react-icons/md";
import ForceUpdateSettingsPage from "views/admin/force-update-settings";

const routes = [
  {
    name: "لوحة الإدارة",
    nameAr: "لوحة الإدارة",
    nameEn: "Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "الطلاب",
    nameAr: "الطلاب",
    nameEn: "Students",
    layout: "/admin",
    path: "students",
    icon: <MdPeople className="h-6 w-6" />,
    component: <StudentsPage />,
  },
  {
    name: "المدرسون والمساعدون",
    nameAr: "المدرسون والمساعدون",
    nameEn: "Instructors & assistants",
    layout: "/admin",
    path: "instructors",
    icon: <MdSchool className="h-6 w-6" />,
    component: <InstructorsPage />,
  },
  {
    name: "الطلاب والمدرسون",
    nameAr: "الطلاب والمدرسون",
    nameEn: "Students & instructors",
    layout: "/admin",
    path: "data-tables",
    icon: <MdPeople className="h-6 w-6" />,
    component: <Navigate to="/admin/students" replace />,
    hideInSidebar: true,
  },
  {
    name: "طلبات الانضمام",
    nameAr: "طلبات الانضمام",
    nameEn: "Join requests",
    layout: "/admin",
    path: "join-requests",
    icon: <MdPersonAdd className="h-6 w-6" />,
    component: <AdminJoinRequestsPage />,
  },
  {
    name: "محافظ الطلاب",
    nameAr: "محافظ الطلاب",
    nameEn: "Student wallets",
    layout: "/admin",
    path: "wallets",
    icon: <MdAccountBalanceWallet className="h-6 w-6" />,
    component: <AdminWalletsPage />,
  },
  {
    name: "طلبات الدعم",
    nameAr: "طلبات الدعم",
    nameEn: "Support requests",
    layout: "/admin",
    path: "support-requests",
    icon: <MdSupportAgent className="h-6 w-6" />,
    component: <SupportRequestsPage />,
  },
  {
    name: "بانرات الصفحة الرئيسية",
    nameAr: "بانرات الصفحة الرئيسية",
    nameEn: "Home banners",
    layout: "/admin",
    path: "home-banners",
    icon: <MdCampaign className="h-6 w-6" />,
    component: <HomeBannersPage />,
  },
  {
    name: "إدارة الكيانات",
    nameAr: "إدارة الكيانات",
    nameEn: "Entities",
    layout: "/admin",
    path: "entities",
    icon: <MdBarChart className="h-6 w-6" />,
    component: <EntitiesPage />,
    hideInSidebar: true,
  },
  {
    name: "الشؤون الأكاديمية",
    nameAr: "الشؤون الأكاديمية",
    nameEn: "Academic",
    layout: "/admin",
    path: "academic",
    icon: <MdSchool className="h-6 w-6" />,
    component: <AcademicPage />,
  },
  {
    name: "الأدوار والصلاحيات",
    nameAr: "الأدوار والصلاحيات",
    nameEn: "Roles & permissions",
    layout: "/admin",
    path: "roles",
    icon: <MdSecurity className="h-6 w-6" />,
    component: <RolesPage />,
  },
  {
    name: "الإشعارات",
    nameAr: "الإشعارات",
    nameEn: "Notifications",
    layout: "/admin",
    path: "notifications",
    icon: <MdNotifications className="h-6 w-6" />,
    component: <NotificationsPage />,
  },
  {
    name: "تفاصيل الإشعار",
    nameAr: "تفاصيل الإشعار",
    nameEn: "Notification details",
    layout: "/admin",
    path: "notifications/:notificationId",
    icon: <MdNotifications className="h-6 w-6" />,
    component: <NotificationDetailsPage />,
    hideInSidebar: true,
  },
  {
    name: "تحليلات التعلم",
    nameAr: "تحليلات التعلم",
    nameEn: "Learning analytics",
    layout: "/admin",
    path: "learning-analytics",
    icon: <MdInsights className="h-6 w-6" />,
    component: <LearningAnalyticsPage />,
  },
  {
    name: "محادثة الكورس",
    nameAr: "محادثة الكورس",
    nameEn: "Course chat",
    layout: "/admin",
    path: "courses/:courseId/chat",
    icon: <MdMenuBook className="h-6 w-6" />,
    component: <AdminCourseChatPage />,
    hideInSidebar: true,
  },
  {
    name: "تحديث التطبيق",
    nameAr: "تحديث التطبيق",
    nameEn: "Force update",
    layout: "/admin",
    path: "force-update",
    icon: <MdSystemUpdateAlt className="h-6 w-6" />,
    component: <ForceUpdateSettingsPage />,
  },
  {
    name: "الملف الشخصي",
    nameAr: "الملف الشخصي",
    nameEn: "Profile",
    layout: "/admin",
    path: "profile",
    icon: <MdAdminPanelSettings className="h-6 w-6" />,
    component: <Profile />,
  },
  {
    name: "تسجيل دخول الإدارة",
    nameAr: "تسجيل دخول الإدارة",
    nameEn: "Admin sign in",
    layout: "/auth",
    path: "admin-sign-in",
    icon: <MdAdminPanelSettings className="h-6 w-6" />,
    component: <AdminSignIn />,
    hideInSidebar: true,
  },
];

export default routes;
